import EnglishPage from "@/pages/second-opinion-thoracic-surgeon-india";
import I18nProvider from "@/components/I18nProvider";

// Russian route for /second-opinion-thoracic-surgeon-india. Reuses the English page component untouched — Layout
// walks its JSX tree and swaps text via the translation memory, so the copy
// lives in exactly one place.
export default function RussianPage() {
  return (
    <I18nProvider locale="ru">
      <EnglishPage />
    </I18nProvider>
  );
}
